import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { IIndustriesState } from "./slice";
import { getIndustriesAsync, getIndustryAsync } from "./actions";

type Reducer = (builder: ActionReducerMapBuilder<IIndustriesState>) => void;

export const getIndustriesReducer: Reducer = (builder) => {
  builder.addCase(getIndustriesAsync.pending, (state) => {
    state.industries.isLoading = true;
  });

  builder.addCase(getIndustriesAsync.fulfilled, (state, actions) => {
    state.industry.isLoading = false;
    state.industries.data = actions.payload;
  });

  builder.addCase(getIndustriesAsync.rejected, (state) => {
    state.industries.isLoading = false;
    state.industries.data = [];
  });
};

export const getIndustryReducer: Reducer = (builder) => {
  builder.addCase(getIndustryAsync.pending, (state) => {
    state.industry.isLoading = true;
  });

  builder.addCase(getIndustryAsync.fulfilled, (state, actions) => {
    state.industry.isLoading = false;
    state.industry.data = actions.payload;
  });

  builder.addCase(getIndustryAsync.rejected, (state) => {
    state.industry.isLoading = false;
    state.industry.data = null;
  });
};
